import { atom } from "recoil";
export const ExchangeAtom = atom({
  key: "ExchangeAtom", // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
});
